import { useState } from "react";
import { useLocation } from "react-router";
import { getParamFromURL, setParamInURL } from "./tools";

type DataType = "string" | "number" | "boolean";

export const useParameter = (
  paramName: string,
  defaultValue: string | number | boolean | null = null,
  dataType: DataType = "string"
): [
  string | number | boolean | null,
  (value: string | number | boolean) => void
] => {
  const currentPage = useLocation();
  const [parameter, setParameter] = useState(() => {
    const value = getParamFromURL(paramName, defaultValue, currentPage.search);
    switch (dataType) {
      case "number":
        return parseFloat(value) || defaultValue;
      case "boolean":
        return value === "true";
      default:
        return value;
    }
  });

  const updateParameter = (value: string | number | boolean): void => {
    setParameter(value);
    setParamInURL(paramName, value);
  };

  return [parameter, updateParameter];
};
